import { api } from './client'

// Server-side HealthKit ingest (iOS native shell only). Mirrors the
// Oura write path: the client reads HealthKit and hands the backend a
// normalized per-day payload for wearable_daily (source='healthkit').
export const healthkitApi = {
  sync: (payload, token) => api.post('/healthkit/sync', payload, token),
}
